<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>法人信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="descriptions_content" v-loading="contentLoading">
      <div class="editBtn" @click="editCompanyBtn">编辑</div>
      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="法人姓名：">
              {{ fixName(companyInfo.etpLegal) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="法人证件类型："> 身份证 </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="法人身份证号码：">
              {{ fixIdcard(companyInfo.etpLegalIdcardCode) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="法人手机号：">
              {{ fixTelephone(companyInfo.etpLegalPhone) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="法人证件有效期：">
              {{
                $parseTime(companyInfo.etpLegalIdcardDateBegin, '{y}-{m}-{d}')
              }}
              至
              {{ $parseTime(companyInfo.etpLegalIdcardDateEnd, '{y}-{m}-{d}') }}
            </el-form-item>
          </el-col>
          <el-col :span="24" style="margin-top: -20px">
            <div style="display: flex; align-items: center">
              <span style="padding-top: 25px">法人证件照（正面）：</span>
              <upLoadImg
                v-model="companyInfo.etpLegalIdcardPicZm"
                :limit="upload.limit"
                :viewImage="upload.viewImage"
              >
              </upLoadImg>
            </div>
          </el-col>
          <el-col :span="24" style="margin-top: 10px">
            <div style="display: flex; align-items: center">
              <span style="padding-top: 25px">法人证件照（背面）：</span>
              <upLoadImg
                v-model="companyInfo.etpLegalIdcardPicFm"
                :limit="upload.limit"
                :viewImage="upload.viewImage"
              >
              </upLoadImg>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      title="编辑法人信息"
      :visible.sync="dialogVisible"
      width="750px"
      :close-on-click-modal="false"
    >
      <editEtplega @childEditBtn="childEditBtn"></editEtplega>
    </el-dialog>
  </div>
</template>
<script>
import { updateC, detailC } from '@/api/user/company'
import upLoadImg from '@/components/uploadImg/index.vue'
import editEtplega from '@/components/editEtplega.vue'
import { desensitizeIdCard,desensitizePhone,desensitizeName } from '@/utils/index'
export default {
  components: {
    editEtplega,
    upLoadImg
  },
  data() {
    return {
      companyInfo: {},
      contentLoading: false,
      dialogVisible: false,
      enterpriseFrom: {
        data: '',
        value1: ''
      },
      upload: {
        limit: 1,
        viewImage: true
      }
    }
  },
  mounted() {
    this.getComanyInfo()
  },
  methods: {
    fixIdcard(v){
       return desensitizeIdCard(v)
    },
    fixTelephone(v){
       return desensitizePhone(v)
    },
    fixName(v){
       return desensitizeName(v)
    },
    childEditBtn() {
      this.dialogVisible=false
      this.getComanyInfo()
      
    },
    getComanyInfo() {
      this.contentLoading = true
      const data = {}
      detailC(data).then((res) => {
        if (res.success) {
          this.companyInfo = res.result
        } else {
          this.$message.error(res.message)
        }
        this.contentLoading = false
      })
    },
    editCompanyBtn() {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.descriptions_content {
  background: #fff;
  padding: 20px;
  position: relative;

  .editBtn {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 14px;
    color: #3d8bfc;
    cursor: pointer;
    z-index: 99;
  }
}

::v-deep .el-dialog__body {
  padding: 10px 20px 30px 20px;
}

::v-deep .djsc_btn {
  display: none;
}

::v-deep .el-dialog__wrapper {
  .djsc_btn {
    display: block;
  }
}

::v-deep .el-upload-list__item-name {
  font-weight: bold;
}

::v-deep .el-form-item__content {
  font-weight: bold;
}
</style>
